export const bumpchartPublications = {
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "width": 400,
  "height": 300,
  "data": [
    {
      "name": "source_0",
      "values": null
    },
    {
      "name": "data_0",
      "source": "source_0",
      "transform": [
        { "type": "filter", "expr": "datum.year > 2006 && datum.year < 2018" },
        {
          "type": "window",
          "params": [null],
          "as": ["rank"],
          "ops": ["rank"],
          "fields": [null],
          "sort": {
            "field": ["count", "diff"],
            "order": ["descending", "descending"]
          },
          "groupby": ["year"]
        },
        {
          "type": "joinaggregate",
          "groupby": ["domain"],
          "fields": ["count"],
          "ops": ["sum"]
        }
      ]
    },
    {
      "name": "aggregated_by_year",
      "source": "data_0",
      "transform": [
        {
          "type": "formula",
          "expr": "datum.year == 2017 ? datum.rank : 0",
          "as": "last_rank"
        },
        {
          "type": "aggregate",
          "groupby": ["domain"],
          "fields": ["count", "last_rank"],
          "ops": ["sum", "max"]
        },
        {
          "type": "formula",
          "expr": "2017",
          "as": "year"
        }
      ]
    }
  ],
  "signals": [
    {
      "name": "width",
      "update": "(containerSize()[0] || 400)",
      "on": [{
        "events": { "source": "window", "type": "resize" },
        "update": "containerSize()[0]"
      }]
    },
    { "name": "x_step", "update": "width / 10" },
    { "name": "y_step", "update": "height / 15" }
  ],
  "marks": [
    {
      "name": "pathgroup",
      "type": "group",
      "from": {
        "facet": {
          "name": "faceted_path_main",
          "data": "data_0",
          "groupby": ["domain"]
        }
      },
      "encode": {
        "update": {
          "width": { "field": { "group": "width" } },
          "height": { "field": { "group": "height" } }
        }
      },
      "marks": [
        {
          "name": "marks",
          "type": "line",
          "style": ["line"],
          "sort": { "field": "datum[\"year\"]" },
          "from": { "data": "faceted_path_main" },
          "encode": {
            "update": {
              "stroke": { "scale": "color", "field": "domain" },
              "x": { "scale": "x", "field": "year" },
              "y": { "scale": "y", "field": "rank" }
            }
          }
        },
        {
          "name": "balls",
          "type": "symbol",
          "style": ["circle"],
          "sort": { "field": "datum[\"year\"]" },
          "from": { "data": "faceted_path_main" },
          "encode": {
            "update": {
              "fill": { "value": "#FFF" },
              "stroke": { "scale": "color", "field": "domain" },
              "x": { "scale": "x", "field": "year" },
              "y": { "scale": "y", "field": "rank" },
              "size": { "scale": "circleRadius", "field": "count" }
            }
          }
        }
      ]
    },
    {
      "name": "labels",
      "type": "text",
      "style": ["text"],
      "from": { "data": "aggregated_by_year" },
      "encode": {
        "update": {
          "text": { "signal": "datum.domain" },
          "fill": { "scale": "color", "field": "domain" },
          "x": { "scale": "x", "field": "year" },
          "dx": { "value": 20 },
          "y": { "scale": "y", "field": "max_last_rank" },
          "dy": { "value": 4 }
        }
      }
    }
  ],
  "scales": [
    {
      "name": "x",
      "type": "point",
      "domain": { "data": "data_0", "field": "year", "sort": true },
      "range": { "step": { "signal": "x_step" } },
      "padding": 0.5
    },
    {
      "name": "y",
      "type": "point",
      "domain": { "data": "data_0", "field": "rank", "sort": true },
      "range": { "step": { "signal": "y_step" } },
      "padding": 0.5
    },
    {
      "name": "weight",
      "type": "sqrt",
      "domain": { "data": "data_0", "field": "count", "sort": true },
      "range": [1, 6]
    },
    {
      "name": "circleRadius",
      "type": "sqrt",
      "domain": { "data": "data_0", "field": "count", "sort": true },
      "range": [15, 80]
    },
    {
      "name": "color",
      "type": "ordinal",
      "domain": null,
      "range": [
        "#539ab6",
        "#d33e41",
        "#71b83d",
        "#7c42c8",
        "#cfa033",
        "#d14dad",
        "#5fb587",
        "#593c78",
        "#a49b58",
        "#8a85d1",
        "#d57641",
        "#3f6130",
        "#d38599",
        "#7c4e2c",
        "#832e46"
      ]
    }
  ],
  "axes": [
    {
      "scale": "x",
      "orient": "bottom",
      "grid": false,
      "title": null,
      "zindex": 0,
      "offset": 10
    },
    {
      "scale": "y",
      "orient": "left",
      "grid": false,
      "title": null,
      "labelOverlap": true,
      "zindex": 0,
      "domain": 0
    }
  ]
};